module.exports = __webpack_public_path__ + "static/media/xero-mockup.99c07ac4.jpg";